import { render, staticRenderFns } from "./ModalResetQuesNumPdfQuestion.vue?vue&type=template&id=4d0871ac&scoped=true"
import script from "./ModalResetQuesNumPdfQuestion.vue?vue&type=script&lang=js"
export * from "./ModalResetQuesNumPdfQuestion.vue?vue&type=script&lang=js"
import style0 from "./ModalResetQuesNumPdfQuestion.vue?vue&type=style&index=0&id=4d0871ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0871ac",
  null
  
)

export default component.exports